import { connect } from "react-redux";
import Section from "src/components/Shared/Containers/Section";
import EditContainer from "../Shared/Containers/EditContainer";
import { toast } from "react-toastify";
import { manageDomainSettings, manageCnameSettings } from "src/actions/site";
import { useEffect, useState } from "react";
import Input from "../Shared/Forms/Inputs/Input";

const DomainSettings = ({ siteData, manageDomainSettings, manageCnameSettings }) => {
  const [baseDomain, setBaseDomain] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [baseCname, setBaseCname] = useState("");
  const [isSubmittingCname, setIsSubmittingCname] = useState(false);

  const setData = () => {
    setBaseDomain(siteData?.base_domain);
  };

  const setCnameData = () => {
    setBaseCname(siteData?.base_cname);
  };

  const handleOnSubmit = async () => {
    try {
      setIsSubmitting(true);
      const message = await manageDomainSettings({ base_domain: baseDomain });
      toast.success(message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOnCnameSubmit = async () => {
    try {
      setIsSubmittingCname(true);
      const message = await manageCnameSettings({ base_cname: baseCname });
      toast.success(message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmittingCname(false);
    }
  };

  useEffect(() => {
    setData();
    setCnameData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteData?.base_domain, siteData?.base_cname]);

  return (
    <>
      <div className="flex flex-col gap-y-4">
        <Section>
          <EditContainer
            title="Base Domain"
            subtitle="Add a base white-labeled domain"
            preview={{ text: baseDomain ? <>{baseDomain}</> : "No Domains" }}
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
            onSuccess={handleOnSubmit}
            onCancel={setData}>
            <div className="min-w-[260px] flex-shrink">
              <div className="mb-4 space-y-4">
                <div className="w-96">
                  <Input
                    type="text"
                    autoComplete="off"
                    name="base-domain"
                    label="Base Domain"
                    inline={true}
                    value={baseDomain}
                    onChange={(e) => setBaseDomain(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </EditContainer>
          <EditContainer
            title="Base CNAME"
            subtitle="Add a base CNAME"
            preview={{ text: baseCname ? <>{baseCname}</> : "No CNAME" }}
            isLoading={isSubmittingCname}
            isDisabled={isSubmittingCname}
            onSuccess={handleOnCnameSubmit}
            onCancel={setCnameData}>
            <div className="min-w-[260px] flex-shrink">
              <div className="mb-4 space-y-4">
                <div className="w-96">
                  <Input
                    type="text"
                    autoComplete="off"
                    name="base-cname"
                    label="Base CNAME"
                    inline={true}
                    value={baseCname}
                    onChange={(e) => setBaseCname(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </EditContainer>
        </Section>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    siteData: state.site,
  };
};

export default connect(mapStateToProps, { manageDomainSettings, manageCnameSettings })(DomainSettings);
